import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ENVIRONMENT } from "src/environments/environment";
import { SessionService } from "src/services/session.service";
import { PrefixJanComponent } from "../components/global/prefixes/impl/prefix-jan/prefix-jan.component";
import { PrefixOmsComponent } from "../components/global/prefixes/impl/prefix-oms/prefix-oms.component";
import { DefaultComponent } from "../default.component";
@Component({
  selector: "app-recovery",
  imports: [MatProgressSpinnerModule, PrefixOmsComponent, PrefixJanComponent, TranslateModule, RouterModule],
  templateUrl: "./recovery.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./recovery.component.less",
})
export class RecoveryComponent extends DefaultComponent {
  private session: SessionService;

  public isLoading: boolean;
  public username: FormControl<string | null> | null;
  public check: FormControl<boolean | null>;
  public env = ENVIRONMENT;

  public constructor() {
    super();
    this.session = inject(SessionService);

    this.isLoading = false;
    this.username = null;
    this.check = new FormControl();
  }

  public async recover(): Promise<void> {
    this.isLoading = true;
    const check = this.check.value;
    const username = this.username?.value;

    try {
      if (!username) throw new Error("Invalid username");

      await this.session.recover({
        usernameoremail: username,
        privateemail: check || false,
      });
    } catch (e) {
      console.error("[RECOVER ERROR]", e);
    } finally {
      this.isLoading = false;
    }
  }
}
